import { Box, Grid } from "@mui/material";
import { clearAllCardSelection, clearOpenSections, setInnCode, setOpenSections } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Feedback from "components/common/Feedback";
import PlanType from "components/common/PlanType";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { tokens } from "styles/Tokens";
import { messages } from "utils/CommonConstants";
import { getHltInncodes, isBookmarked } from "utils/CommonFunctions";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import Basictabs from "../../common/Tabs";
import { fetchPlanDetailAsync } from "./PlanDetail.slice";
import PlanDetailsContent from "./PlanDetailsContent";
import { tabDetails } from "./TabsConfig";

export default function PlanDetails() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const selectedPlanDetail: any = useAppSelector((state) => state.planDetails.planDetails);
  const showLoader: boolean | undefined = useAppSelector((state) => state.planDetails.planDetailShowLoader);
  const innCodes = getHltInncodes();
  const [searchParams] = useSearchParams();
  const isShareable = searchParams.get("isshareable") as string;
  const { id: planId, secId } = useParams();
  const [multipleInncodeFeedback, setmultipleInncodeFeedback] = useState<any>();
  const [multipleInncodePlan, setmultipleInncodePlan] = useState(false);
  const { isMobileScreen } = useContext(ThemeContext);

  useEffect(() => {
    if (isShareable) return;
    dispatch(clearOpenSections());
    dispatch(fetchPlanDetailAsync({ planId, innCode: location?.state?.innCode || innCode }));
  }, [dispatch, planId, innCode]);

  useEffect(() => {
    if (isShareable) {
      const otherInnCode = selectedPlanDetail?.meta?.planAvailableInncodes?.split(",");
      const hasOtherInncode = otherInnCode?.length > 0;
      if (selectedPlanDetail?.id) {
        setmultipleInncodeFeedback({
          innCode: multipleInncodeFeedback?.innCode,
          otherInnCodes: selectedPlanDetail?.meta?.planAvailableInncodes?.split(",")
        });
        dispatch(setInnCode(multipleInncodeFeedback?.innCode));
        if (hasOtherInncode) setmultipleInncodePlan(true);
        navigate(location.pathname, { state: { backURL: "/library" } });
        return;
      }

      noAccessRedirect();

      innCodes?.splice(innCodes?.indexOf(hasOtherInncode ? otherInnCode[0] : innCode), 1);
      const props: any = {
        planId,
        innCode: hasOtherInncode ? otherInnCode[0] : innCode,
        innCodes: innCodes
      };
      setmultipleInncodeFeedback({
        innCode: hasOtherInncode ? otherInnCode[0] : innCode
      });
      dispatch(fetchPlanDetailAsync({ ...props }));
    }
  }, [dispatch, isShareable, selectedPlanDetail]);

  const noAccessRedirect = () => {
    const noAccessCondition =
      (Object.keys(selectedPlanDetail).length !== 0 && !selectedPlanDetail?.meta?.planAvailableInncodes) ||
      selectedPlanDetail?.meta?.planAvailableInncodes === null;
    if (noAccessCondition)
      navigate(`/`, {
        state: {
          hasNoAccess: true,
          message: messages.planNotFound
        }
      });
  };

  useEffect(() => {
    dispatch(clearAllCardSelection());
    if (selectedPlanDetail?.sections?.length) {
      dispatch(setOpenSections({ [secId ?? selectedPlanDetail?.sections[0]?.id]: true }));
    }
  }, [dispatch, selectedPlanDetail]);

  return (
    <>
      <Feedback
        form=""
        actionStatus={{ shouldShow: multipleInncodePlan, variant: "warning" }}
        message={"You are viewing Plan details for " + multipleInncodeFeedback?.innCode + ". "}
      />

      <Grid>
        {!showLoader && (
          <>
            <Grid
              sx={{
                backgroundColor: tokens.Background.General.Primary,
                padding: isMobileScreen ? "16px" : "40px 24px 40px 32px",
                borderRadius: "12px"
              }}
            >
              {selectedPlanDetail?.planType || location?.state?.redirectFromSuggested ? (
                <Box marginBottom={"8px"}>
                  <PlanType
                    planType={selectedPlanDetail?.planType}
                    brandDeadlineDate={
                      selectedPlanDetail?.brandDeadlines && selectedPlanDetail?.brandDeadlines[0]?.deadline
                    }
                    initiativeName={selectedPlanDetail?.initiativeName}
                  />
                </Box>
              ) : (
                <></>
              )}

              <PlanDetailsContent
                selectedPlanDetail={selectedPlanDetail}
                plansType="AllPlans"
                isPlanBookmark={isBookmarked(selectedPlanDetail?.id)}
                redirectFromDashboard={location?.state?.redirectFromDashboard ?? false}
                individualPropertyInncode={location.state?.individualPropertyInncode ?? null}
              />
            </Grid>
            <Grid marginY={2}>
              <Basictabs tabDetails={tabDetails(selectedPlanDetail, "AllPlans")} alignItems="left" />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}
